// API Configuration
// This file reads from environment variables to determine the API base URL

const API_URLS: Record<string, string> = {
  development: 'http://localhost:4000',
  production: 'https://cards.tpcstld.me',
};

// Get the API base URL based on environment
// You can override this with REACT_APP_API_URL environment variable
const getApiBaseUrl = (): string => {
  // Priority 1: Explicit override via environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Priority 2: Use environment-specific default
  const env = process.env.NODE_ENV || 'development';
  return API_URLS[env] || API_URLS.development;
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URLs
export const apiUrl = (path: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${cleanPath}`;
};

// Log the current API URL (helpful for debugging)
console.log('API Base URL:', API_BASE_URL);

const config = {
  API_BASE_URL,
  apiUrl,
};

export default config;
